export const modalText = {
  onSubmit: '你的盖章需求已收到！我们将会在一个工作日内处理你的证明需求，后续可登录系统查看盖章状态并下载盖章后的证明',
  onRejectSuccess: '驳回信息已发送，待员工查看'
};